import cn from 'classnames';
import { PlateLeaf, type PlateLeafProps } from 'platejs/react';

import styles from './SpoilerElement.module.scss';

export function SpoilerElement(props: PlateLeafProps) {
	return <PlateLeaf {...props} as="span" className={cn(styles.spoiler, props.attributes?.className)} />;
}
